/** Identity key for a Friend name: trim + collapse spaces + case-fold. */
export function normalizeFriendName(name) {
    return name.trim().replace(/\s+/g, " ").toLowerCase();
}
//# sourceMappingURL=friend-name.js.map